<template>
    <Layout>
        <div class="container" >
            <h3 class="green align-center" style="text-align:center;margin-top:2rem;">List of Service Providers</h3>
            <table class="table " ID="Services">
                <tbody>
                    <tr width="35">
                    
                            <th rowspan="1" colspan="1" style="text-align: center; width:50px;">#</th>
                        <th rowspan="1" colspan="1" style="text-align:center;">Category</th>
                    
                        <th rowspan="1" colspan="1" style="text-align:center;">Jurisdictions</th>
                        <th rowspan="1" colspan="1" style="text-align: center;">Purpose</th>
                    </tr>
                    <tr>
                        <td style="text-align: center; width:50px;">1</td>
                        <td>Auditors, Banks, Affiliates, Brokers, Custodians, Administrators and Registrars</td>
                        <td>Egypt, United Arab Emirates, Saudi Arabia, Oman, Jordan, Kuwait, UK, USA, Bahrain, Pakistan, Kenya, Nigeria, Qatar, Bahrain, Morocco, Palestine, Lebanon, Bangladesh, Botswana, Cote d&#145;Ivoire, Ghana, Mauritius, South Africa, Sri Lanka, Tanzania, Uganda, Vietnam, Zimbabwe, Rwanda, London, Namibia, Malawi, Tunisia, BVI, Cayman Islands, Bermuda and Denmark</td>
                        <td>Providing the relevant services to our clients - For audit purposes</td>
                    </tr>
                    <tr>
                        <td style="text-align: center; width:50px;">2</td>
                        <td>Technology Providers</td>
                        <td>USA, France and Egypt</td>
                        <td>Analytics, technical support and troubleshooting of issues in our IT infrastructure.</td>
                    </tr>
                    <tr>
                        <td style="text-align: center; width:50px;">3</td>
                        <td>Marketing Providers</td>
                        <td>USA. UK, France, Australia and Nigeria</td>
                        <td>Social Media, Internet Marketing, Digital Advertising and Public Relations</td>
                    </tr>
                    <tr>
                        <td style="text-align: center; width:50px;">4</td>
                        <td>Parent Company (EFG Hermes Holding SAE)</td>
                        <td>Egypt</td>
                        <td>Supporting functions, Online Platforms and HR records (for EFG Staff)</td>
                    </tr>
                </tbody>
            </table>
            <p style="margin-top: 10px;">EFG-Hermes is regulated by the Financial Regulatory Authority.</p>
            <p style="margin-top: 10px;">&#169; 2021 EFG-Hermes Holding S.A.E.</p>
            <p style="margin-top: 10px;">All rights reserved.</p>
        </div>
    </Layout>
</template>
<script>
import Layout from "@/components/layouts/Layout.vue";
export default {
    name:"ProviderList",
    components: {Layout}
}
</script>